var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "errors-list-dialog-container" },
    [
      _c(_setup.CustomDialogHeaderComponent, {
        attrs: { headerTitle: _setup.texts.title },
      }),
      _c(_setup.LfErrorListComponent, {
        attrs: {
          errors: _setup.props.componentProps.errors,
          description: _setup.texts.body,
          icon: _setup.icon,
        },
      }),
      _c(_setup.CustomDialogActionButtonsComponent, {
        attrs: {
          showSecondaryButton: false,
          primaryButtonText: _setup.texts.primaryButtonText,
          mainAction: _setup.closeDialog,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }